import { useCallback, useEffect, useState } from 'react';

export const useInventoryContext = (api) => {
  const [ctx, setCtx] = useState({ can_see_costs: false, pending_reviews: 0, to_restock: 0 });
  const reload = useCallback(() => api.get('/context').then(setCtx).catch(() => {}), [api]);
  useEffect(() => { reload(); }, [reload]);
  return { ctx, reload };
};
